import { Role } from './roles.js';

const FIRST_ROUTE: Record<Role, string> = {
  ADMIN: '/dashboard',
  OPS: '/dashboard',
  TECH: '/dashboard',
  PARTNER: '/orders',
  DOWNSTREAM: '/orders',
};

export function getFirstAllowedRoute(role: Role): string {
  return FIRST_ROUTE[role] || '/profile';
}
